
<template>
  <!--新增消息模板-->
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'addMsgTemplate',
  data () {
    let decoratorOptions = {
      title: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入标题' },
          { min: 1, max: 20, message: '标题为1-20个字' }
        ]
      },
      tpl_mark: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入模板ID' },
          { min: 1, max: 20, message: '模板ID为1-20个字' }
        ]
      },
      category_id: {
        rules: [{ required: true, message: '请选择消息类型' }]
      },
      content: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '请输入内容'}]
      }
    };
    return {
      formList: [
        {
          label: '模板标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入模板标题',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '模板ID',
          inputType: 'input',
          options: [],
          placeholder: '请输入模板ID',
          props: ['tpl_mark', decoratorOptions.tpl_mark]
        },
        {
          label: '消息类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择消息类型',
          props: ['category_id', decoratorOptions.category_id]
        },
        {
          label: '内容',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入内容',
          props: ['content', decoratorOptions.content]
        }
      ],
      formKey: {
        title: '',
        tpl_mark: '',
        category_id: '',
        content: ''
      },
      addParam: {
        url: '/message_tpl',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/message_tpl/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/message_tpl/',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  mounted () {
    let paramArr = [{ index: 2, key: 'msg_type', scope: 'formList' }];
    this.marketingManageSelect(paramArr);
  },
  methods: {
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    detailResHandle (res) {
      console.log('处理详情返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/marketing/msgTemplate/addMsgTemplate.vue